export const env = import.meta.env.VITE_APP_ENV;

export const amplitudeToken = import.meta.env.VITE_AMPLITUDE_TOKEN;
export const partnerPlatformHost = import.meta.env.VITE_PARTNER_PLATFORM_HOST;
export const appHost = import.meta.env.VITE_APP_HOST;

export const MUIProLicense = import.meta.env.VITE_MUI_PRO_LICENSE;
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
